import config from '../../../config.json';
import * as ethers from 'ethers';
import Web3Modal from 'web3modal';
import CoinbaseWalletSDK from '@coinbase/wallet-sdk';
import WalletConnect from '@walletconnect/web3-provider';

function setVerificationLoading( status, connectionId ) {
	const verificationButtons = document.querySelectorAll(
		`.wpcoingate-verification-connect[data-connectionid="${ connectionId }"]`
	);

	verificationButtons.forEach( ( verificationButton ) => {
		if ( status ) {
			verificationButton.innerHTML = 'Verifying Assets...';
		} else {
			verificationButton.innerHTML = 'Verify Assets';
		}
	} );
}

function setVerifiedStatus( message, connectionId ) {
	const verificationPlaceholders = document.querySelectorAll(
		`.wpcoingate-verification-placeholder[data-connectionid="${ connectionId }"]`
	);

	verificationPlaceholders.forEach( ( placeholder ) => {
		placeholder.classList.remove( 'unloaded' );
		placeholder.innerHTML = message;
	} );
}

async function outputVerificationResults(
	signature,
	connectionId = null,
	postId = null,
	onSuccess = () => null
) {
	setVerificationLoading( true, connectionId );

	try {
		let proxy = web3CoinGateRestUrl;

		// vanilla fetch request with body.
		const response = await fetch( proxy, {
			method: 'POST',
			body: JSON.stringify( {
				signature,
				// Adding dynamic connection id.
				...( connectionId && { connection_id: connectionId } ),
				...( postId && { post_id: postId } ),
			} ),
			headers: {
				'Content-Type': 'application/json',
			},
		} );

		const data = await response.json();

		setVerifiedStatus( data?.message, connectionId );

		// Hiding the verification button, on success.
		if ( data?.success ) {
			onSuccess();
		}
	} catch ( err ) {
		console.error( err );
	} finally {
		setVerificationLoading( false, connectionId );
	}
}

window.addEventListener( 'load', () => {
	const verificationButtons = document.querySelectorAll(
		'.wpcoingate-verification-connect'
	);

	verificationButtons.forEach( ( verificationButton ) => {
		let provider;
		let hasWallet = false;
		const web3modalConfiguration = {
			cacheProvider: false,
			providerOptions: {
				coinbasewallet: {
					package: CoinbaseWalletSDK,
					options: {
						appName: 'Web3 Coin Gate',
						infuraId: process.env.INFURA_KEY,
					},
				},
				walletconnect: {
					package: WalletConnect,
					options: {
						infuraId: process.env.INFURA_KEY,
					},
				},
			},
		};

		verificationButton.addEventListener( 'click', async () => {
			const hasConnectionId =
				'connectionid' in verificationButton.dataset;
			const connectionId = hasConnectionId
				? Number( verificationButton.dataset.connectionid )
				: null;
			const outputType = verificationButton.dataset.outputtype;

			const postId = Number( verificationButton.dataset.postid );
			const isPageGate = verificationButton.dataset.pagegate === 'true';
			const walletConnectedPlaceholders = document.querySelectorAll(
				`.wptokengate-wallet-connected-placeholder[data-connectionid="${ connectionId }"]`
			);

			const web3modal = new Web3Modal( web3modalConfiguration );

			web3modal.clearCachedProvider();

			const currentProvider = provider
				? provider
				: await web3modal.connect();

			// Updating the provider
			provider = currentProvider;

			const web3 = new ethers.providers.Web3Provider( currentProvider );

			const currentSigner = web3.getSigner();

			if ( ! hasWallet ) {
				const requiredAccount = await currentSigner.getAddress();

				walletConnectedPlaceholders.forEach(
					( connectedPlaceholder ) => {
						connectedPlaceholder.innerHTML =
							'Wallet Connected: ' + requiredAccount;
					}
				);

				verificationButtons.forEach( ( verificationButton ) => {
					verificationButton.innerHTML = 'Verify Assets';
					hasWallet = true;
				} );
			} else {
				const signature = await currentSigner.signMessage(
					config.message
				);

				await outputVerificationResults(
					signature,
					connectionId,
					// Not passing post id, so that the server won't interpret the post output type.
					isPageGate ? postId : null,
					() => {
						verificationButton.style.display = 'none';

						walletConnectedPlaceholders.forEach(
							( walletConnectedPlaceholder ) => {
								walletConnectedPlaceholder.style.display =
									'none';
							}
						);
					}
				);
			}
		} );
	} );
} );
